import * as React from 'react';
import {
  Card,
  Checkbox,
  Container,
  Grid,
  Row,
  Spacer,
  Text,
} from '@nextui-org/react';
import { GraphQLError } from 'graphql';
import {
  GetClientsDocument,
  useAddClientMutation,
  useGetClientsQuery,
} from '@src/generated/hooks';
import { AppFullWidthContainer } from '@src/layouts/app/AppFullWidthContainer';
import { AppFullWidthLoader } from '@src/layouts/app/AppFullWidthLoader';
import { AppModalCreateNewButton } from '@src/layouts/app/AppModalCreateNewButton';
import { AppTitle } from '@src/layouts/app/AppTitle';
import { ClientListItem } from '@src/layouts/clients/ClientListItem';
import { showApiToastError } from '@src/util/toast';

interface ClientsListProps {}

/**
 * @name ClientsList
 * @description tbd...
 */
export function ClientsList(_props: ClientsListProps) {
  // const {} = props

  // Hooks
  const [showArchived, setShowArchived] = React.useState(false);

  // GraphQL
  const { data, error, loading } = useGetClientsQuery({
    variables: {
      showArchived,
    },
  });
  const [addClientMutation, { loading: newClientLoading }] =
    useAddClientMutation({
      refetchQueries: [
        { query: GetClientsDocument, variables: { showArchived } },
      ],
    });

  // Setup
  const clients = data?.clients;
  const errorLoading = error || !clients;

  // Handlers
  const onAddClient = async (name: string) => {
    try {
      await addClientMutation({
        variables: {
          name,
        },
      });
    } catch (error) {
      const errors = error as GraphQLError;
      showApiToastError(errors, 'Campaign');
    }
  };

  return (
    <AppFullWidthContainer>
      <AppFullWidthContainer>
        <Row justify="flex-start" align="center">
          <AppTitle>Campaigns</AppTitle>
          <Spacer x={1} />
          <AppModalCreateNewButton
            okText="Create Campaign"
            title="Create New Campaign"
            placeholder="Campaign Name"
            newText="New"
            isOnOkLoading={newClientLoading}
            onOk={(value) => onAddClient(value)}
          />
        </Row>
        <Spacer y={0.5} />
        <Row>
          <Checkbox
            size="sm"
            isSelected={showArchived}
            onChange={() => setShowArchived(!showArchived)}
          >
            Show archived
          </Checkbox>
        </Row>
      </AppFullWidthContainer>
      <Spacer y={1} />
      {loading && <AppFullWidthLoader />}
      {!loading && !errorLoading && (
        <Grid.Container gap={1} css={{ p: 0 }}>
          {clients.map((client) => {
            return <ClientListItem client={client} key={client.id} />;
          })}
        </Grid.Container>
      )}
      {!loading && errorLoading && (
        <Container>
          <Spacer y={3} />
          <Row justify="center">
            <Card css={{ mw: '400px' }}>
              <Card.Body>
                <Text color="error">
                  There was an error loading campaigns. Try refreshing the page.
                </Text>
              </Card.Body>
            </Card>
          </Row>
        </Container>
      )}
    </AppFullWidthContainer>
  );
}
